import { Pipe, PipeTransform } from '@angular/core';
import { MonitoredTrain } from '../models/monitored-train';

@Pipe({
  name: 'websiteLinkDisabledReason'
})
export class WebsiteLinkDisabledReasonPipe implements PipeTransform {

  transform(url: string): string  {
    if (url.includes('INVALID_TRAIN_CURRENT_SERVICE')) {
      if (url.includes('INVALID_TRAIN_NEXT_SERVICE')) {
        return 'I18N_MONITORING.NO_CURRENT_AND_NEXT_SERVICES'
      }
      return 'I18N_MONITORING.NO_CURRENT_SERVICE' 
    } else {
      return 'I18N_MONITORING.NO_NEXT_SERVICE'
    } 
  }

}
